import AxiosInstance from "./api";

export const ForeignCurrencyPaymentLedgerService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/foreign-currency-payment-ledgers/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/foreign-currency-payment-ledgers/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/foreign-currency-payment-ledgers", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/foreign-currency-payment-ledgers/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/foreign-currency-payment-ledgers/" + id);
  },
};
